import { createContext, useContext } from "react";
import type { CurrSection } from "../../../containers/AutomationForm/types";
import type { ActionGroupType } from "../../../types/candidate";

export interface FlowCanvasHandlers {
  activeItem: CurrSection;
  activeAction: string | undefined;
  onClickTrigger: () => void;
  onClickAction: (hash?: string) => void;
  onChangeAction: (
    integrationId: string,
    actionId: string,
    actionGroupType?: ActionGroupType,
  ) => void;
  onSelectBlock: (instanceId: number) => void;
  onSelectBranch: (instanceId: number, branchHash: string) => void;
  onSelectNestedLoop: (instanceId: number) => void;
  /** Selects the ROOT loop. Legacy selects it as CurrSection
   * `{ type: "looping", hash }` (distinct from a nested loop's
   * `{ type: "nested-loop", instanceId }`), routed by SectionSwitch to the
   * LoopingSection. */
  onSelectLooping: (hash: string) => void;
}

export const FlowCanvasHandlersContext = createContext<
  FlowCanvasHandlers | undefined
>(undefined);

/** Incremented by FlowCanvas on pane click; 0 outside FlowCanvas. */
export const FlowCanvasMenuDismissContext = createContext(0);

export const useFlowCanvasHandlers = (): FlowCanvasHandlers => {
  const value = useContext(FlowCanvasHandlersContext);
  if (value === undefined) {
    throw new Error("useFlowCanvasHandlers must be used inside FlowCanvas");
  }
  return value;
};
